import React from 'react';
import {
  IndentedTextContent,
  StickyTableData,
  TableRow as StyledTableRow,
} from '../../TableRow.styles';
import { Text } from '../../../../../../../../../../../../../../CommonComponents/OPL/Text/Text';
import { Value } from '../Value/Value';
import { Totals } from '../../../../../../FlowTable.meta';
import { Box } from '../../../../../../../../../../../../../../CommonComponents/OPL/Box/Box';
import { TruncatedText } from '../../../../../../../../../../../../../../CommonComponents/OPL/Text/TruncatedText';

interface Props {
  name?: string;
  totals: Totals[];
  indentation?: number;
  collapsableHeaderIds: string[];
  hasHeaderSelected(id: number): boolean;
  hasShowCollapsed(id: number): boolean;
}

export const GroupTotal = ({
  name = 'Total',
  totals,
  indentation = 0,
  hasHeaderSelected,
  collapsableHeaderIds,
  hasShowCollapsed,
}: Props) => {
  const hasTotals = totals.find(({ value }) => value !== null);

  if (!hasTotals) {
    return null;
  }

  return (
    <StyledTableRow>
      <StickyTableData columnPosition={0}>
        <IndentedTextContent indentation={indentation} isExpandable>
          {indentation > 0 && <Box width="32px" />}

          <TruncatedText fontWeight={600} textAlign="left">
            {name}
          </TruncatedText>
        </IndentedTextContent>
      </StickyTableData>

      {totals.map(({ value, collapsed, headerId }, index) => {
        if (hasHeaderSelected(headerId)) {
          return null;
        }

        const isCollapsableHeader = collapsableHeaderIds.includes(headerId.toString());

        const isCollapsed = hasShowCollapsed(headerId) ? !collapsed : collapsed;

        if (isCollapsableHeader && isCollapsed) {
          return null;
        }

        return (
          <React.Fragment key={index}>
            {index === 0 ? (
              <StickyTableData columnPosition={1}>
                <Text fontWeight={600} variant="tabular" textAlign="right">
                  <Value value={value} />
                </Text>
              </StickyTableData>
            ) : (
              <td>
                <Text fontWeight={600} variant="tabular" textAlign="right">
                  <Value value={value} />
                </Text>
              </td>
            )}
          </React.Fragment>
        );
      })}
    </StyledTableRow>
  );
};
